<template>
  <div class="main-section baselineImportation">
    <table>
      <tr>
        <th v-for="header in headers" :key="header.value">
          <span class="item_text">{{ header.text }}</span>
        </th>
      </tr>
      <tr v-if="baselines.length === 0">
        <th>
          <span class="item_text"></span>
        </th>
        <th>
          <span class="item_text"></span>
        </th>
        <th>
          <span class="item_text"></span>
        </th>
        <th>
          <span class="item_text">Baseline não importado</span>
        </th>
        <th>
          <span class="item_text"></span>
        </th>
        <th>
          <span class="item_text"></span>
        </th>
        <th>
          <span class="item_text"></span>
        </th>
      </tr>
      <tr v-for="(item, index) in baselines" :key="index">
        <th>
          <span class="item_text">{{ `${item.MONTH}/${item.YEAR}` }}</span>
        </th>
        <th>
          <span class="item_text">{{ item.VIEW }}</span>
        </th>
        <th>
          <span class="item_text">{{ item.CUSTCODE }}</span>
        </th>
        <th>
          <span class="item_text">{{ item.INDICATOR_DIMENSION }}</span>
        </th>
        <th>
          <span class="item_text">{{ item.PRODUCT }}</span>
        </th>
        <th>
          <span class="item_text">{{ item.QTD }}</span>
        </th>
        <th>
          <span class="item_text">{{ item.QTD_FAT | currencyFormat }}</span>
        </th>
      </tr>
    </table>
  </div>
</template>

<script>
import { currencyFormat } from 'filters';

export default {
  name: 'BaselineTable',
  props: ['headers', 'baselines'],
  filters: { currencyFormat },
  data() {
    return {
      month: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
    };
  }
};
</script>

<style lang="scss" scoped>
.baselineImportation {
  background-color: white;
  width: 100%;
  border-radius: 6px;
  border: 2px solid rgba(0, 0, 0, 0.1);
  table {
    width: 100%;
    tr {
      border-bottom: 2px solid rgba(0, 0, 0, 0.1);
      color: rgba(0, 0, 0, 0.6);
      th {
        font-size: 0.89em;
        position: relative;
        width: 14%;
        padding: 1.2rem 2rem;
      }
      th:nth-child(1) {
        width: 12%;
      }
      th:nth-child(2) {
        width: 10%;
      }
      th:nth-child(3) {
        width: 22%;
        padding-left: 1rem;
      }
    }
    tr:nth-child(1) {
      th {
        color: rgba(0, 0, 0, 0.7);
        font-size: 1em;
        font-weight: 600;
        padding: 1.2rem 2rem;
      }
    }
  }
}
.item_text {
  position: absolute;
  top: 50%;
  left: 15%;
  text-align: left;
  transform: translateY(-50%);
  font-size: 0.9em;
}
</style>
